import { useCallback, useContext } from 'react'
import { AppStateContext } from './AppStateContext'

interface UserRoleResult {
  saveUserRole: (userRole: string | undefined) => void
  removeUserRole: () => void
}

export const useUserRole: () => UserRoleResult = () => {
  const { setUserRoleInStore, removeUserRoleFromStore } = useContext(AppStateContext)
  const saveUserRole = useCallback((userRole: string | undefined) => setUserRoleInStore(userRole), [setUserRoleInStore])

  const removeUserRole = useCallback(() => removeUserRoleFromStore(), [removeUserRoleFromStore])

  return {
    saveUserRole,
    removeUserRole,
  }
}
